type IntegrationsEnv = Record<string, string | undefined>;

/**
 * Explicit property read (not a bare `import.meta.env`) so Vite inlines it
 * and the Jest transform can map it.
 */
function currentEnv(): IntegrationsEnv {
  return {
    VITE_FEATURE_INTEGRATIONS: import.meta.env.VITE_FEATURE_INTEGRATIONS,
  };
}

/** #120: the Integrations module is on only where the flag is set. */
export function isIntegrationsEnabled(
  env: IntegrationsEnv = currentEnv()
): boolean {
  return env.VITE_FEATURE_INTEGRATIONS === 'true';
}
